<template>
    <div class="featured-resource ">
        <pageSearch  :isNewPage="false" @banner_search="banner_search" :tit="tit"></pageSearch>
        <div class="page-cont">   
            <ul class="two-nav" v-if="navList.length!=0">
                <li class="nav-label" :class="(index+1)==twoNavIndex?'active':''" v-for="(item,index) in navList" :key="index" @click="twoNav_click(item,index)">{{ item.name }}</li>
            </ul> 
            <ul class="three-nav">
                <li  class="nav-list" :class="(index+1)==threeNavIndex?'active':''" v-for="(item,index) in twoNav" :key="index" @click="threeNav_click(item,index)">{{ item.name }}</li>
            </ul>
            <div v-loading="listLoad" >
                <div v-if="listInfo&&listInfo.length!=0">
                    <ul class="resource-list" >
                        <li v-for="(item,index) in listInfo" :key="index" class="list" @click="jump_prompt(item)">
                            <p class="list-tit" v-html="item.resource_row"></p>
                            <div class="list-cont">
                                <div class="info-txt" v-for="(list,num) in item.subtitleList" :key="num">
                                    <b>[{{ list.label }}]：</b>
                                    <p v-html="list.text"></p>
                                </div> 
                            </div>
                            
                        </li>
                    </ul>
                    <el-pagination  
                        class="page-wrap"  
                        @current-change="changePage" 
                        @size-change="sizeChange"
                        background
                        :current-page="pageInfo.pageNum" 
                        :page-count="pageInfo.pageTotal" 
                        :page-size="pageInfo.pageSize"
                        :page-sizes="[9, 18, 27, 45, 90]"
                        :total="pageInfo.total"
                        layout="total, sizes, prev, pager, next, jumper" >
                    </el-pagination>
                </div>
                <p v-else class="no-data">暂无数据～</p>
            </div>
        </div>
        <deductScore ref="deduct_score" v-if="isShowTip" :show.sync="isShowTip" flag="2"></deductScore>
    </div>
</template>

<script>
import deductScore from '../comps/deduct_score.vue'
import {globalSearchTree,resourceSearch,saveFrontLog} from '../../io/api.js'
import pageSearch from '../comps/page_search.vue'
export default {
    components:{
        pageSearch,
        deductScore
    },
    data () {
        return {
            tit:this.$route.query.word||'',
            link:this.$route.query.link||'', 
            oneLabel:this.$route.query.label||'', 
            tableVal:this.$route.query.table||'',
            searchVal:'',
            listLoad:false,
            navList:[],
            twoNavIndex:'',
            twoNav:[], 
            threeNavIndex:'',
            threeNavName:'',
            
            listInfo:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 9,
            },
            isShowTip:false,
             
        }
    },
    mounted(){
        const hasUrlNav = !!(this.$route.query.table && this.$route.query.label);
        // URL 带 table + label：按 URL 还原选中
        // 否则刷新时重置导航选中，避免残留
        if (!hasUrlNav) {
            const navEntry = performance.getEntriesByType
                ? performance.getEntriesByType('navigation')[0]
                : null;
            const isReload = navEntry
                ? navEntry.type === 'reload'
                : (typeof performance !== 'undefined'
                    && performance.navigation
                    && performance.navigation.type === 1);
            if (isReload) {
                this.oneLabel = '';
                this.tableVal = '';
                this.threeNavIndex = '';
                this.twoNavIndex = '';
            }
        } else {
            // 确保与 URL 一致
            this.tableVal = this.$route.query.table || '';
            this.oneLabel = this.$route.query.label || '';
        }
        this.getList();
    },
    methods:{
         //banner检索
        banner_search(val){ 
            this.searchVal=val;
            this.tableVal='';
            this.threeNavIndex='';
            this.getList(); 
        }, 
        twoNav_click(item,index,click=true){ 
            this.twoNavIndex=index+1;
            this.threeNavIndex='';
            this.twoNav=item.children||[];
            //选中2级目录，自动默认三级菜单第一个个选项
            if(item.children && item.children.length){
                if(click){
                    this.threeNav_click(item.children[0],0)
                }else{
                    let matched = false;
                    item.children.forEach((list,num) => {
                        if(list.tableValue==this.tableVal){
                            matched = true;
                            this.threeNav_click(list,num)
                        }
                    });
                    // 未匹配到时回退选中第一个，避免残留旧索引
                    if (!matched) {
                        this.threeNav_click(item.children[0], 0);
                    }
                }
            } 
        },
        threeNav_click(item,index){
            this.threeNavIndex=index+1  ;
            this.tableVal=item.tableValue;
            this.threeNavName = item.name || '';
            // 与列表请求只记一次日志：分页不走这里
            this.logResourceList();
            this.get_resourceSearch(1)
        },
        // 特色资源列表查看日志（以当前三级菜单名为准）
        logResourceList() {
            const label = this.threeNavName || this.$route.query.label || this.oneLabel || '';
            saveFrontLog({
                moduleName: '特色资源',
                operationType: '查看更多',
                logContent: `查看【${this.tit || ''}】的【${label}】列表数据`,
            });
        },
        getList(){
            let params={
                link: this.link,
                table: this.tableVal||'',
                keywords:this.searchVal, 
            } 
            globalSearchTree(params).then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.navList=data.treeStructure.length!=0&&data.treeStructure[0].children||[];   
                    if (!this.navList.length) {
                        this.twoNav = [];
                        this.twoNavIndex = '';
                        this.threeNavIndex = '';
                        return;
                    }
                    //同时存在label和table，首页三级过来的
                    if(this.oneLabel&&this.tableVal){
                        let found = false;
                        this.navList.forEach((item,index)=>{
                            if(item.label==this.oneLabel){ 
                                found = true;
                                this.twoNav_click(item,index,false)
                            }
                        })
                        if (!found) {
                            this.twoNav_click(this.navList[0],0)
                        }
                    }else{ 
                        this.twoNav_click(this.navList[0],0)
                    }
                    
                }else{
                    this.$message.error('请求失败～')
                }
                 this.treeLoad=false;
            })
        },
        get_resourceSearch(num){
            this.listLoad=true;
            this.pageInfo.pageNum=num?num:this.pageInfo.pageNum
            let params={
                link:this.link,
                table:this.tableVal,
                searchWord:this.searchVal,
                secondSearchWord:'',
                page: this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize,

            }
            resourceSearch(params).then(res=>{
                let {code,msg,data}=res.data;
                if(code==0){
                    this.listInfo=data.list||[];
                    this.pageInfo.total=data.totalCount;
                }else{
                    this.$message.error('检索失败～')
                }
                this.listLoad=false;
            })
        },
        jump_prompt(item){
            this.isShowTip=true; 
            this.$nextTick(()=>{
                let searchWord=this.searchVal?this.searchVal:'';
                this.$refs.deduct_score.get_checkScoreStatus(item,searchWord)
            })
        },
        changePage(num) {
            this.pageInfo.pageNum = num; 
            this.get_resourceSearch()
        },
        sizeChange(val) {
             this.pageInfo.pageSize=val;
             this.get_resourceSearch()
        },
    }
}
</script>

<style lang="less" scoped>
.featured-resource{
    // .resource-tit{
    //     // text-align: center;
    //     font-size: 24px;
    //     font-weight: bold;
    //     line-height: 40px;
    // }
    // .resource-search{
    //     padding:20px 0;
        
    //     ::v-deep .el-input-group__append{
    //         background: #396de7;
    //         border: 1px solid #396de7;
    //         color: #fff; 
    //     }
    // }
    .two-nav{
        display: flex;
        flex-wrap: wrap;
        border-bottom:2px solid #386DE8;
        .nav-label{
            font-weight: bold;
            font-size: 18px;
            flex-shrink: 1;
            // width: 150px;
            padding:0 40px;
            height: 40px;
            line-height: 40px;
            //margin:0 0px 10px 0;
            background: #fff;//#FCFCFC;
            border: 1px solid #fff;
            border-radius: 4px 4px 0 0;
            text-align: center;
            cursor: pointer;
            &:hover, &.active{
                color: #386DE8;
                border-bottom: none;
            }
        }
    }
    .navHover{
        background: #EAF1FF;
        border : 1px solid #A0BDFF;
        box-shadow: 0px 2px 4px 0px rgba(22,93,255,0.1);
        color: #386DE8;
    }
    .three-nav{
        padding-top:20px;
        display: flex;
        // gap: 20px;
        // grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        flex-wrap: wrap;
        grid-template-columns: repeat(auto-fill, 100px);
        margin-right: -30px;
        .nav-list{
            // width: 180px;
            padding:0 14px;
            height: 40px;
            font-size: 16px;
            line-height: 40px; 
            border: 1px solid #E9ECEF;
            text-align: center;
            margin-right: 24px;
            margin-bottom: 10px;
            cursor: pointer;
            &:hover, &.active{
                .navHover();
            }
        }
    }

    .resource-list{
        font-size: 16px;
        display: flex;
        text-align: center;
        flex-wrap: wrap;
        padding-top: 20px;
        margin-right: -100px;
        .list{
            width: 390px;
            height: 120px;
            padding:10px;
            // background: #EAF1FF;
            margin :0 20px 20px 0;
            background: url('../../assets/images/resource/border.png') no-repeat right bottom;
            background-size:contain;
            box-shadow:6px 8px 10px 0px #d3d8dc;
            cursor: pointer;
            .list-tit{
                // font-weight: bold;
                font-size: 16px;
                text-align: left;
                padding-bottom: 10px;
                white-space:nowrap;//(文字不换行);
                overflow:hidden;//( 溢出隐藏);
                text-overflow:ellipsis;//( 文本有溢出加省略号 );
            }
            .list-cont{
                overflow: hidden;
                height: 60px;
            }
            .list-info{
                width:980px ;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                p{
                    width: 220px;
                    border:1px solid #ccc;
                    margin-right: 20px;
                    line-height: 40px;
                    margin-bottom: 20px;
                    color: #396de7;
                }
            }
            .info-txt{
                line-height: 30px;
                display: flex;  
                font-size: 14px; 
                b{
                    white-space: nowrap;
                }
                p{
                    white-space:nowrap;//(文字不换行);
                    overflow:hidden;//( 溢出隐藏);
                    text-overflow:ellipsis;//( 文本有溢出加省略号 );
                    display:inline-block;//(flex布局)
                }
            }

        }
    }
    .no-data{
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        min-height: 400px;
    }
}
</style>